// extracted by mini-css-extract-plugin
export default {"leftSideBar":"LeftSideBar_leftSideBar__tdF0x","font1":"LeftSideBar_font1__5UttS","font2":"LeftSideBar_font2__OdG8h","font":"LeftSideBar_font__UCFGY"};